import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { ButtonComponent } from 'src/components/button/button.component';
import { IconModule } from 'src/components/icon/icon.module';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

@Component({
  selector: 'dialog-coming-soon',
  templateUrl: './dialog-coming-soon.component.html',
  standalone: true,
  imports: [DialogModule, IconModule, ButtonComponent],
})
export class _DialogComingSoonComponent implements OnInit, OnDestroy {
  visible: boolean = false;
  visible$?: Subscription;

  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {
    this.visible$ = this.globalService.showComingSoon$.subscribe((visible) => {
      this.visible = visible;
    });
  }

  ngOnDestroy(): void {
    this.visible$?.unsubscribe();
  }

  protected _hide() {
    this.globalService.hideComingSoon();
  }

  protected _onVisibleChange(visible: boolean) {
    if (visible) this.globalService.showComingSoon();
    else this.globalService.hideComingSoon();
  }
}
